import Http from '@/api/http/';

export default class AiReportAuditConfig extends Http {
  constructor() {
    super();
  }

  /**
   * 获取AI审核列表
   * @param {string} companyId - 企业id
   * @param {string} brandId - 品牌id
   * @param {string} reportTemplateName - 模板名称
   * @param {string} auditConfigName - 规则名称
   * @param {integer} page - 页码
   * @param {integer} rows - 每页条数
   */
  aiReportAuditConfig_getAiReportAuditConfigList() {
    return super.post('aiReportAuditConfig/getAiReportAuditConfigList', ...arguments);
  }

  /**
   * 新增或更新AI审核配置
   * @param {string} auditConfigName - 配置名称
   * @param {string} brandId - 品牌id
   * @param {string} reportTemplateId - 模板id
   * @param {Array} auditConfigReportInfoList - 考核点审核配置
   * @param {Array} auditConfigTitleList - 报告抬头字段
   * @param {string} titleCustomPrompt - 报告抬头提示词
   * @param {integer} titleDefault - 报告抬头是否默认：0-自定义，1-默认
   */
  aiReportAuditConfig_addOrUpdateAiReportAuditConfig() {
    return super.post('aiReportAuditConfig/addOrUpdateAiReportAuditConfig', ...arguments);
  }

  /**
   * 获取模板的审核配置信息
   * @param {string} reportTemplateId - 模板id
   */
  aiReportAuditConfig_getReportTemplateAiAuditDetail() {
    return super.post('aiReportAuditConfig/getReportTemplateAiAuditDetail', ...arguments);
  }

  /**
   * 更新AI审核配置状态
   * @param {string} aiReportAuditConfigId - AI审核配置id
   * @param {integer} status - 状态：1-启用，2-禁用
   */
  aiReportAuditConfig_updateAiReportAuditConfigStatus() {
    return super.post('aiReportAuditConfig/updateAiReportAuditConfigStatus', ...arguments);
  }

  /**
   * 获取AI审核配置详情
   * @param {string} aiReportAuditConfigId - AI审核配置id
   */
  aiReportAuditConfig_getAiReportAuditConfigDetail() {
    return super.post('aiReportAuditConfig/getAiReportAuditConfigDetail', ...arguments);
  }

  /**
   * 预保存模板报告考核点
   * @param {Object} reportInfo - 模板报告考核点信息
   */
  aiReportAuditConfig_preSaveSingleReportInfo() {
    return super.post('aiReportAuditConfig/preSaveSingleReportInfo', ...arguments);
  }

  /**
   * AI审核模板预报告考核点
   * @param {string} customPrompt - 自定义提示词
   * @param {string} reportTemplateId - 模板id
   * @param {string} reportTemplateInfoId - 模板考核点id
   */
  aiReportAuditConfig_aiAuditPreReportInfo() {
    return super.post('aiReportAuditConfig/aiAuditPreReportInfo', ...arguments);
  }

  /**
   * 删除AI审核配置
   * @param {string} aiReportAuditConfigId - AI审核配置id
   */
  aiReportAuditConfig_deleteAiReportAuditConfig() {
    return super.post('aiReportAuditConfig/deleteAiReportAuditConfig', ...arguments);
  }
}
